import axios from 'axios';
const backendAxios = axios.create();
export default backendAxios;
